/*
 * @Author: zhangzhian@linshimuye.com
 * @Date: 2022-05-26 21:52:18
 * @LastEditors: Gyan
 * @LastEditTime: 2023-10-21 14:52:05
 * @FilePath: \dhr_frontend\src\mixins\export.js
 * @Description: 导出mixin文件
 * @RouteImport: import exportMixin from '@/mixins/export';
 */

import { downloadBlob } from '@/utils/helpers';
// import qs from 'qs'
export default {
  data () {
    return {
      exportLoading: false
    }
  },
  methods: {
    /**
     * 导出文件
     * @param {string} url 导出url
     * @param {object} params 请求参数
     * @param {string} method 请求方式
     * @param {function} exportPreCallBack 导入前回调
     * @param {function} cb 到处成功后回调方法
     * @param {boolean} isQs 是否对参数qs处理
     * @param {boolean} isSetLsmyAccount 是否设置lsmyAccount
     * @param {string} envKey 接口服务key
     * @param {object} customConfig 自定义配置
     * @param {string} loadingKey loading的key
     * @return
     */
    exportDownLoad ({
      url = '',
      method = 'post',
      params = null,
      isQs = false,
      exportPreCallBack,
      cb = () => { this.$message.success('导出成功') },
      loadingKey = 'exportLoading',
      envKey = 'VUE_APP_PROXY_DING_OA',
      isSetLsmyAccount = false,
      customConfig = {}
    } = {}) {
      typeof exportPreCallBack === 'function' && exportPreCallBack()
      this[loadingKey] = true;
      if (params && isQs && method === 'post') {
        // params = qs.stringify(params)
        let formData = new FormData();
        for(let key in params) {
          [undefined, null].includes(params[key]) ? null : formData.append(key, params[key])
        }
        params = formData
      }
      let config = [];
      switch (method) {
        case 'get':
          config = [{
            params,
            responseType: 'blob',
            headers: process.env.NODE_ENV === 'development' || isSetLsmyAccount
              ? {
                lsmyAccount: this.$store.state?.user?.userInfo?.code,
              }
              : null,
            ...customConfig
          }]
          break;
        case 'post':
          config = [
            params,
            {
              responseType: 'blob',
              headers: process.env.NODE_ENV === 'development' || isSetLsmyAccount
                ? {
                  lsmyAccount: this.$store.state?.user?.userInfo?.code,
                }
                : null,
              ...customConfig
            }
          ]
          break;

      }
      return this.$axios[method](
        '/' + process.env[envKey] + url,
        ...config
      )
        .then(({ data, headers }) => {
          const filename =
            headers['content-disposition'].match(/filename=(.*)/)[1];
          downloadBlob(data, decodeURIComponent(filename));
          typeof cb === 'function' && cb(data, filename)
        })
        .finally(() => {
          this[loadingKey] = false;
        });
    }
  }
}